var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('request-egr', {
    attrs: {
      "is-individual": _vm.isIndividual,
      "on-create": _vm.createRequest,
      "fields": _vm.fields,
      "total": _vm.total,
      "is-searching": _vm.isSearching
    },
    on: {
      "search": _vm.handleSearch
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6328f80e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/requestEgr/RequestEgrContainer.vue
// module id = 1115
// module chunks = 0